import { Injectable } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { map } from 'rxjs/operators';
import { auth, firestore } from 'firebase';

import { AngularFirestore, AngularFirestoreDocument } from '@angular/fire/firestore';
import { UserInterface } from '../models/user';

@Injectable({
  providedIn: 'root'
})
export class OauthService {

  constructor(private afsAuth: AngularFireAuth, private afs: AngularFirestore) { }

  loginGoogleUser(){
    return this.afsAuth.auth.signInWithPopup(new auth.GoogleAuthProvider())
    .then(credential => this.updateUserData(credential.user))
  }

  loginMailUser(mail, pass){
    return this.afsAuth.auth.signInWithEmailAndPassword(mail, pass).then(credential => this.updateUserData(credential.user))
  }

  logoutUser(){
    return this.afsAuth.auth.signOut();
  }

  isAuth(){
    return this.afsAuth.authState.pipe(map(auth => auth));
  }

  private updateUserData(user){
    const userRef: AngularFirestoreDocument<any> = this.afs.doc(`users/${user.uid}`);
    const data: UserInterface = {
      id: user.uid,
      name: user.displayName,
      email: user.email
    }
    return userRef.set(data, { merge: true})
  }

  isUserAdmin(userUid){
    return this.afs.doc<UserInterface>(`users/${userUid}`).valueChanges()
  }

  isUserGranted(userUid){
    return this.afs.doc<UserInterface>(`users/${userUid}`).valueChanges()
  }

  UpdateUserDashboardMonitoring(userUID, body, _space, projID){
    // let space = {};
    // space[_space] = body;
    // console.log(space);
    // let fullPayload = {};
    // fullPayload['Spaces'] = {  [_space]: body};
    //se quitan los objetos en variable dashboard.
    //////////////////////////////////////////////////////
    
    ///////////////////////////////////////////////////
      // body.forEach(element => {
      //   if(element.sub != undefined)
      //     {
      //       element.sub = '';
      //     }
      //   dummyDash.push(element);
      // });
    let name = "Spaces."+projID+"."+_space;
    this.afs.collection('users')
    .doc('/'+ userUID)
    .update({[name]: body})
    .then(() => {
      return 'ok'
    })
    .catch(function(error){
      console.error('Error: ', error)
      return -1
    })
  }

  UpdateUserDashboardControl(userUID, body, _space, projID){
    // let space = {};
    // space[_space] = body;
    // console.log(space);
    // let fullPayload = {};
    // fullPayload['Spaces'] = {  [_space]: body};
    //se quitan los objetos en variable dashboard.
    //////////////////////////////////////////////////////
    
    ///////////////////////////////////////////////////
      // body.forEach(element => {
      //   if(element.sub != undefined)
      //     {
      //       element.sub = '';
      //     }
      //   dummyDash.push(element);
      // });
    let name = "IOSpaces."+projID+"."+_space;
    this.afs.collection('users')
    .doc('/'+ userUID)
    .update({[name]: body})
    .then(() => {
      return 'ok'
    })
    .catch(function(error){
      console.error('Error: ', error)
      return -1
    })
  }

  UpdateUserDashboardGeren(userUID, bodyO, _space, projID){
    // let space = {};
    // space[_space] = body;
    // console.log(space);
    // let fullPayload = {};
    // fullPayload['Spaces'] = {  [_space]: body};
    //se quitan los objetos en variable dashboard.
    //////////////////////////////////////////////////////
    
    ///////////////////////////////////////////////////
    let body = [];
    for(let s in bodyO)
    {
      body.push({chart: '', cols: bodyO[s].cols, dragEnabled: bodyO[s].dragEnabled, id: bodyO[s].id, label: bodyO[s].label, resizeEnabled: bodyO[s].resizeEnabled, rows: bodyO[s].rows, widgetType: bodyO[s].widgetType, x: bodyO[s].x, y: bodyO[s].y, filter: bodyO[s].filter})
    }
    let dummyDash = [];
    for(let s in body)
    {
      dummyDash.push(body[s])
      dummyDash[s].chart = '';
    }
      // body.forEach(element => {        
      //   element.chart = '';
      //   dummyDash.push(element);
      // });
    let name = "GerenSpaces."+projID+"."+_space;
    this.afs.collection('users')
    .doc('/'+ userUID)
    .update({[name]: dummyDash})
    .then(() => {
      return 'ok'
    })
    .catch(function(error){
      console.error('Error: ', error)
      return -1
    })
  }

  UpdateSpaceName(userUID, name, projID){
    this.afs.collection('users')
    .doc('/'+ userUID)
    .update({['SpacesAlias.'+projID]: name})
    .then(() => {
      return 'ok'
    })
    .catch(function(error){
      console.error('Error: ', error)
      return -1
    })
  }

  UpdateIOSpaceName(userUID, name, projID){
    this.afs.collection('users')
    .doc('/'+ userUID)
    .update({['IOSpacesAlias.'+projID]: name})
    .then(() => {
      return 'ok'
    })
    .catch(function(error){
      console.error('Error: ', error)
      return -1
    })
  }

  getUserDashboardMonitoring(userUID){
    return this.afs.doc(`users/${userUID}`).valueChanges();
  }

  updateUserSpaceName(userUID, names, projID){
    let name = projID
    this.afs.collection('users')
    .doc('/'+ userUID)
    .update({[name]: names})
    .catch(function(error){
      console.error('Error: ', error)
      return -1
    })
  }
  
  updateUserIOSpaceName(userUID, names, projID){
    let name = projID
    this.afs.collection('users')
    .doc('/'+ userUID)
    .update({[name]: names})
    .catch(function(error){
      console.error('Error: ', error)
      return -1
    })
  }

  createUserDash(userUID, body, projID){
    let dummyDash = [];
      body.forEach(element => {
        if(element.sub != undefined)
          {
            element.sub = '';
          }
        dummyDash.push(element);
      });
    let name = "Spaces."+projID+".0";
    this.afs.collection('users')
    .doc('/'+ userUID)
    .update({[name]: dummyDash})
    .catch(function(error){
      console.error('Error: ', error)
      return -1
    })

    //creo alias de espacios
    name = "SpacesAlias."+projID;
    this.afs.collection('users')
    .doc('/'+ userUID)
    .update({[name]: ['Default']})
    .catch(function(error){
      console.error('Error: ', error)
      return -1
    })

    //creo limite de espacio default 3
    name = "SpaceLimit";
    this.afs.collection('users')
    .doc('/'+ userUID)
    .update({[name]: 5})
    .catch(function(error){
      console.log('Error: ', error)
      return -1
    })
    
  }

  createUserIODash(userUID, body, projID){
    let dummyDash = [];
      body.forEach(element => {
        if(element.sub != undefined)
          {
            element.sub = '';
          }
        dummyDash.push(element);
      });
    let name = "IOSpaces."+projID+".0";
    this.afs.collection('users')
    .doc('/'+ userUID)
    .update({[name]: dummyDash})
    .catch(function(error){
      console.error('Error: ', error)
      return -1
    })

    //creo alias de espacios
    name = "IOSpacesAlias."+projID;
    this.afs.collection('users')
    .doc('/'+ userUID)
    .update({[name]: ['Default']})
    .catch(function(error){
      console.error('Error: ', error)
      return -1
    })

    //creo limite de espacio default 3
    name = "SpaceLimit";
    this.afs.collection('users')
    .doc('/'+ userUID)
    .update({[name]: 5})
    .catch(function(error){
      console.log('Error: ', error)
      return -1
    })
    
  }

  createUserGerenDash(userUID, body, projID){
    let dummyDash = [];
      body.forEach(element => {
        if(element.sub != undefined)
          {
            element.sub = '';
          }
        dummyDash.push(element);
      });
    let name = "GerenSpaces."+projID+".0";
    this.afs.collection('users')
    .doc('/'+ userUID)
    .update({[name]: dummyDash})
    .catch(function(error){
      console.error('Error: ', error)
      return -1
    })

    //creo alias de espacios
    name = "GerenSpacesAlias."+projID;
    this.afs.collection('users')
    .doc('/'+ userUID)
    .update({[name]: ['Default']})
    .catch(function(error){
      console.error('Error: ', error)
      return -1
    })

    //creo limite de espacio default 3
    name = "SpaceLimit";
    this.afs.collection('users')
    .doc('/'+ userUID)
    .update({[name]: 5})
    .catch(function(error){
      console.log('Error: ', error)
      return -1
    })
    
  }

  createUserDashSpace(userUID, index, spaces, projID){
    let name = "Spaces."+projID+"."+index;
    this.afs.collection('users')
    .doc('/'+ userUID)
    .update({[name]: [{cols: 2, rows: 1, y: 0, x: 0, dragEnabled: true, widgetType: 'Clock', resizeEnabled: false, minItemCols: 2, label: 'Fecha/Hora Actual'}]})
    .catch(function(error){
      console.error('Error: ', error)
      return -1
    })

    
    name = "SpacesAlias."+projID;
    this.afs.collection('users')
    .doc('/'+ userUID)
    .update({[name]: spaces})
    .catch(function(error){
      console.error('Error: ', error)
      return -1
    })
  }

  createUserIODashSpace(userUID, index, spaces, projID){
    let name = "IOSpaces."+projID+"."+index;
    this.afs.collection('users')
    .doc('/'+ userUID)
    .update({[name]: [{cols: 2, rows: 1, y: 0, x: 0, dragEnabled: true, widgetType: 'Clock', resizeEnabled: false, minItemCols: 2, label: 'Fecha/Hora Actual'}]})
    .catch(function(error){
      console.error('Error: ', error)
      return -1
    })

    
    name = "SpacesAlias."+projID;
    this.afs.collection('users')
    .doc('/'+ userUID)
    .update({[name]: spaces})
    .catch(function(error){
      console.error('Error: ', error)
      return -1
    })
  }

  deleteUserSpace(userUID, body, names, projID){
    let name = "Spaces."+projID;
    this.afs.collection('users')
    .doc('/'+ userUID)
    .update({[name]: body})
    .catch(function(error){
      console.log('Error: ', error)
      return -1
    })

    name = "SpacesAlias."+projID;
    this.afs.collection('users')
    .doc('/'+ userUID)
    .update({[name]: names})
    .catch(function(error){
      console.error('Error: ', error)
      return -1
    })


  }

  deleteUserIOSpace(userUID, body, names, projID){
    let name = "IOSpaces."+projID;
    this.afs.collection('users')
    .doc('/'+ userUID)
    .update({[name]: body})
    .catch(function(error){
      console.log('Error: ', error)
      return -1
    })

    name = "IOSpacesAlias."+projID;
    this.afs.collection('users')
    .doc('/'+ userUID)
    .update({[name]: names})
    .catch(function(error){
      console.error('Error: ', error)
      return -1
    })


  }

  updatePreference(userUID, projSel){
    this.afs.collection('users')
    .doc('/'+ userUID)
    .update({'preferences': projSel})
    .catch(function(error){
      console.error('Error: ', error)
      return -1
    })
  }  
  
}
